<template>
  <div
    class="en-details"
    v-if="value"
    @click="close"
  >
    <div class="content">
      {{ content ? content : "您还没进行输入" }}
    </div>
  </div>
</template>

<script>
export default {
  name: "enDetails",
  props: {
    content: {
      type: String,
      default: ""
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit("input", false);
    }
  }
};
</script>

<style lang="scss">
  .en-details {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 55;
    width: 100%;
    height: 100%;
    background-color: #ffffff;

    .content {
      color: #333;
      width: 80%;
      left: 10%;
      position: relative;
      text-align: left;
      font-size: 14px;
      line-height: 20px;
      top: 50%;
      transform: translate(0, -50%);
    }
  }
</style>
